export default {
  data() {
    return {
      cacheList: [],
      initTableList: [],
    }
  },
  computed: {},
  mounted() {},
  methods: {
    setOperationTypeList(list, listName) {
      if (list.length == 0) return
      list.filter((item) => {
        item.operationType = this.$divisions.operationTypeEnum.enum_U.value
        item.isOld = true
      })
      this.$data[listName] = list
    },
    deOperationType(list, newKeyPath, listName, oldKeyPath) {
      if (list.length == 0) return

      if (!this.$data[listName]) {
        this.$data[listName] = []
        list.filter((item) => {
          item.operationType = this.$divisions.operationTypeEnum.enum_I.value
          this.$data[listName].push(item)
        })
      }
      let oldIds = this.$data[listName]
        .map((item) => this.getFieldValue(oldKeyPath, item))
        .filter((item) => item !== undefined)
      let newIds = list
        .map((item) => this.getFieldValue(newKeyPath, item))
        .filter((item) => item !== undefined)
      let defIds = []
      if (oldIds.length > newIds.length) {
        defIds = this.$baseLodash.difference(oldIds, newIds)
      } else {
        defIds = this.$baseLodash.difference(newIds, oldIds)
      }
      list.filter((item) => {
        if (
          defIds.includes(this.getFieldValue(newKeyPath, item)) ||
          this.getFieldValue(newKeyPath, item) == undefined
        ) {
          item.operationType = this.$divisions.operationTypeEnum.enum_I.value
          this.$data[listName].push(item)
        }
      })
      this.$data[listName].filter((item, index) => {
        if (
          newIds.includes(
            this.getFieldValue(oldKeyPath, item) ||
              this.getFieldValue(newKeyPath, item)
          )
        ) {
          if (item.isOld) {
            item.operationType = this.$divisions.operationTypeEnum.enum_U.value
          }
        } else {
          if (
            this.isEqualCodeEnum(
              item.operationType,
              this.$divisions.operationTypeEnum.enum_I
            )
          ) {
            this.$data[listName].splice(index, 1)
          } else {
            item.operationType = this.$divisions.operationTypeEnum.enum_D.value
          }
        }
      })
    },
    deleteOperationType(id, listName, keyPath) {
      if (!id) return
      this.$data[listName].filter((item) => {
        if (this.getFieldValue(keyPath, item) == id) {
          item.operationType = this.$divisions.operationTypeEnum.enum_D.value
        }
      })
    },
    addOperationType(data, listName) {
      if (!data) return
      data.operationType = this.$divisions.operationTypeEnum.enum_I.value
      this.$data[listName].push(data)
    },
    getCacheList(listName) {
      return this.$baseLodash.cloneDeep(this.$data[listName])
    },
  },
}
